import { toast } from "react-toastify";
import {fetchaddRatingGroupFailure, fetchaddRatingGroupSuccess } from "./reducer";
import {setSuccessMessage } from "../../toastMessage/action";
import {determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { getAllRatingGroup } from "../thunk";
import { RATING_GROUP_API } from "../../constants/constants";

export const addRatingGroup = (jsonObj, setLoading,setModalOpen) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${RATING_GROUP_API}`, 'POST', jsonObj).then((response) => {
        if (!response.error) {
            setLoading(false)
            setModalOpen(false)
            dispatch(fetchaddRatingGroupSuccess(response))
            dispatch(getAllRatingGroup(setLoading))
            dispatch(setSuccessMessage(true))
        }
        if (response.error) {
            dispatch(fetchaddRatingGroupFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}